import {SharedDevicesSortType} from '../../types/shared-devices.type';
import {OrderType} from '../../types/order.type';

export class FetchSharedDevices {
  static readonly type = '[Shared Devices] Fetch shared devices';

  constructor(public order?: string) {
  }
}

export class SearchSharedDevices {
  static readonly type = '[Shared Devices] Search shared devices';

  constructor(public search: string) {
  }
}


export class SetSharedDevicesPage {
  static readonly type = '[Shared Devices] Set shared devices page';

  constructor(public page: number) {
  }
}

export class SortSharedDevices {
  static readonly type = '[Shared Devices] Sort shared devices';

  constructor(public payload: {
    sort: SharedDevicesSortType,
    order: OrderType
  }) {
  }
}

export class EnableSharedDeviceLoader {
  static readonly type = '[Shared Devices] Turn on loader';
}

export class DisableSharedDeviceLoader {
  static readonly type = '[Shared Devices] Turn off loader';
}
